export enum RiskAssessmentReportIndicatorMitigationStatus {
  COMPLETED = "COMPLETED",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}
